var React = require('react');

function LiquorIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("path",{"d":"M11.21 29.5l-.55-.32a.53.53 0 0 1 0-.91l1.1-.63a.53.53 0 0 0 0-.91l-1.1-.63a.53.53 0 0 1 0-.91l1.1-.63a.53.53 0 0 0 0-.91l-1.1-.65a.53.53 0 0 1 0-.91l1.1-.63a.53.53 0 0 0 0-.91l-1.1-.63a.53.53 0 0 1 0-.91l1.1-.63a.53.53 0 0 0 0-.91l-1.1-.63a.53.53 0 0 1 0-.91l.28-.16a.53.53 0 0 0 .26-.46V7.46m-6.4.48a14.66 14.66 0 0 0 .52-3.42A14.66 14.66 0 0 0 4.8 1.1.8.8 0 0 0 4 .5H1.3a.8.8 0 0 0-.8.8v6.43a.8.8 0 0 0 .8.8H4a.8.8 0 0 0 .8-.59zm13.6.6h2.72a.8.8 0 0 0 .8-.8V1.3a.8.8 0 0 0-.8-.8H18.4a.8.8 0 0 0-.78.6 14.66 14.66 0 0 0-.52 3.42 14.66 14.66 0 0 0 .52 3.42.8.8 0 0 0 .78.59zM5 6.92a33.12 33.12 0 0 0 6.17.54 33.12 33.12 0 0 0 6.18-.54m0-4.81a33.12 33.12 0 0 0-6.17-.54A33.12 33.12 0 0 0 5 2.11","fill":"none","stroke":"#303c42","strokeLinecap":"round","strokeLinejoin":"round","data-name":"Layer 1"})));
}

LiquorIcon.displayName = "LiquorIcon";

LiquorIcon.defaultProps = {"viewBox":"0 0 22.42 30"};

module.exports = LiquorIcon;

LiquorIcon.default = LiquorIcon;
